import { EvaluationChartFeedbackFormField } from 'types/form/evaluationChart';
import { RegisterEvaluationChartFormField } from 'types/form/student';

export const RegisterPracticeChartDefaultValues = {
  chartTypeNum: undefined,
  chartName: '',
};

export type TRegisterEvaluationChartDefaultValues = {
  [RegisterEvaluationChartFormField.CourseInfoId]: number | undefined;
  [RegisterEvaluationChartFormField.ChartRound]: number | undefined;
  [RegisterEvaluationChartFormField.ChartTypeNum]: number | undefined;
};

export const RegisterEvaluationChartDefaultValues: TRegisterEvaluationChartDefaultValues =
  {
    [RegisterEvaluationChartFormField.CourseInfoId]: undefined,
    [RegisterEvaluationChartFormField.ChartRound]: undefined,
    [RegisterEvaluationChartFormField.ChartTypeNum]: undefined,
  };

export const EvaluationChartFeedbackDefaultValues = {
  [EvaluationChartFeedbackFormField.EvaluationChartId]: null,
  [EvaluationChartFeedbackFormField.Score]: null,
  [EvaluationChartFeedbackFormField.FeedbackContent]: '',
  [EvaluationChartFeedbackFormField.FeedbackImage]: '',
};
